// Auto-generated normalizer for table: CAR_BOOKING.VehiculoMantenimiento
export function vehiculoMantenimientoNormalize(row) {
  return {
    idMantenimiento: row.idMantenimiento ?? row.IdMantenimiento ?? row['idMantenimiento'] ?? 0,
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    tipo: row.tipo ?? row.Tipo ?? row['tipo'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    fechaProgramada: row.fechaProgramada ?? row.FechaProgramada ?? row['fechaProgramada'] ?? '',
    fechaReal: row.fechaReal ?? row.FechaReal ?? row['fechaReal'] ?? '',
    costo: row.costo ?? row.Costo ?? row['costo'] ?? '',
    km: row.km ?? row.Km ?? row['km'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? '',
  };
}